<template lang="pug">
    .container.content(v-if="edit && contents && contents.length")
        .content-wrap.column.is-offset-1.is-10
            .field
                label.label(v-if="labels.text" v-html="labels.text")
                quill-editor(
                    ref="quill"
                    @input="$emit('change', section.id, content.id, 'text', $event)"
                )
    .container.content(v-else-if="contents && contents.length")
        .content-wrap.column.is-offset-1.is-10
            .hyperlink(v-if="hyperlink && hyperlink.href && hyperlink.type === 'external'")
                h5(v-if="hyperlink.name")
                    a(:href="hyperlink.href" :title="hyperlink.name" target="hyperlink.target") {{ hyperlink.name }}
                a(:href="hyperlink.href" :title="hyperlink.name" target="hyperlink.target") {{ hyperlink.href }}
            .description(v-if="content && content.text" v-html="content.text")
</template>

<script>

import _ from 'lodash'
// import Vue from 'vue'

export default {
    name: 'ServiceDescription',
    props: {
        edit: {
            type: Boolean,
            default: false,
        },
        section: {
            type: Object,
            required: true,
        },
    },
    computed: {
        contents() {
            return this.section.contents || []
        },
        content() {
            return this.contents.find(content => content.key === 'content')
        },
        hyperlink() {
            return _.get(this.content, 'hyperlink')
        },
        labels() {
            const content = this.section.contents.find(content => content.key === 'content')
            let labels = {
                text: _.get(content, 'labels.text'),
            }

            return labels
        },
        placeholders() {
            const content = this.section.contents.find(content => content.key === 'content')
            let placeholders = {
                text: _.get(content, 'placeholders.text'),
            }

            return placeholders
        },
    },
    mounted() {
        if (this.$refs.quill && this.placeholders.text) {
            this.$refs.quill.quill.root.setAttribute('data-placeholder', this.placeholders.text)
        }
    }
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins";

    .content h5
        margin-bottom: 0
    .hyperlink,
    .description
        padding: 12px 0

</style>
